import React, { ReactNode, useEffect, useState } from 'react';

import { Auth, Hub } from 'aws-amplify';
import 'src/../configuration/amplify.config.js';

export interface IAuthenticatorProps {
    children: ReactNode;
}
export const Authenticator = ({ children }: IAuthenticatorProps) => {
    const [currentUser, setCurrentUser] = useState<any>(null);

    useEffect(() => {
        // Store current path before any authentication check
        const currentPath = window.location.pathname;
        if (currentPath !== '/' && !sessionStorage.getItem('intendedPath')) {
            sessionStorage.setItem('intendedPath', currentPath);
        }

        Hub.listen('auth', (data) => {
            switch (data.payload.event) {
                case 'signIn':
                    setCurrentUser(data.payload.data);
                    break;
                case 'signOut':
                    setCurrentUser(null);
                    break;
            }
        });

        Auth.currentAuthenticatedUser()
            .then((user) => setCurrentUser(user))
            .catch(() => {
                console.error('No user signed in');
                // Route user to Cognito sign-in UI if no user is found signed in
                Auth.federatedSignIn({ customProvider: 'AmazonFederate' });
            });
    }, []);

    return <>{currentUser && children}</>;
};
